import { TranslateService } from '@ngx-translate/core';

export interface Capability {
  key: string;
  label: string;
}

/**
 * Obtener capacidades
 * @param translateService Servicio de traducción
 * @returns Capacidades
 */
function getCapabilities(translateService: TranslateService): Capability[] {
  return [
    {
      key: 'LEASING',
      label: translateService.instant('common.models.capabilities.leasing'),
    },
    {
      key: 'CONFIG',
      label: translateService.instant(
        'common.models.capabilities.configuration'
      ),
    },
    {
      key: 'LEASINGLOG',
      label: translateService.instant('common.models.capabilities.log'),
    },
    {
      key: 'QUERY',
      label: translateService.instant('common.models.capabilities.query'),
    },
  ];
}

export { getCapabilities };
